var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShow)?_c('q-btn',{class:_vm.classes,attrs:{"name":_vm.props.name,"color":"primary","disable":_vm.disable,"label":_vm.title},on:{"click":_vm.skipForm}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }